<template>
    <div class="workflows__list">
        <div class="workflows__list_header">
            <view-actions
                :title="'Workflows'"
                :cancel-button-active="false"
                :custom-button-active="true"
                :custom-button-text="'Explore logs'"
                :submit-button-text="'Create workflow'"
                :submit-button-active="true"
                @emit-submit="redirectToWorkflowsAdd"
                @emit-custom="redirectToWorkflowsLog"
            />
        </div>
        <div class="workflows__list_tabs">
            <div class="container">
                <div class="columns is-variable is-0">
                    <div class="column is-narrow">
                        <component-button
                            :name="'workflows-list-view-org-units'"
                            :theme="'nav'"
                            :size="'medium'"
                            :is-active="routeQueryView === 'org-units'"
                            :secondary-theme="routeQueryView === 'org-units' ? 'primary' : ''"
                            @click="switchView('org-units')"
                        >Organisation units
                        </component-button>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            :name="'workflows-list-view-groups'"
                            :theme="'nav'"
                            :size="'medium'"
                            :is-active="routeQueryView === 'groups'"
                            :secondary-theme="routeQueryView === 'groups' ? 'primary' : ''"
                            @click="switchView('groups')"
                        >Groups
                        </component-button>
                    </div>
                    <div class="column"></div>
                </div>
            </div>
        </div>
        <div class="workflows__list_main">
            <component-list
                v-if="routeQueryView"
                :key="rerenderIndex"
                :component-table="LmsSuperadminWorkflowsListTable"
                :component-table-name="'workflows'"
                :filter-select-active="true"
                :filter-select-items="filtersSelect"
                :filter-select-prefix="''"
                :empty-state-title="'Workflows will appear here. Go ahead and create one by clicking Create workflow.'"
                :get-pagination-getter="'getLmsSuperadminWorkflowsPagination'"
                :get-items-getter="'getLmsSuperadminWorkflows'"
                :get-items-dispatch="'lmsSuperadminWorkflowsGet'"
                :get-items-dispatch-trigger-name="'get-workflows'"
                :get-items-dispatch-params="{ type: routeQueryView }"
                :item-name="['workflow', 'workflows']"
                :table-preferences-active="true"
            />
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentList from '@/components/default/shared/ComponentList'
import LmsSuperadminWorkflowsListTable from '@/components/lms/superadmin/workflows/list/LmsSuperadminWorkflowsListTable'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  name: 'lms-superadmin-workflows-list',
  components: { ComponentButton, ComponentList, ViewActions },
  data () {
    return {
      LmsSuperadminWorkflowsListTable,
      rerenderIndex: 0
    }
  },
  computed: {
    filtersSelect () {
      let filtersArr = []

      if (this.routeQueryView === 'org-units') {
        filtersArr.push({
          key: 'targets',
          label: 'Organisation unit',
          type: 'org-units'
        })
      }

      if (this.routeQueryView === 'groups') {
        filtersArr.push({
          key: 'targets',
          label: 'Groups',
          type: 'multiselect',
          getItemsGetter: 'getLmsSuperadminGroupsMappedIdName',
          getItemsGetterMapped: 'getLmsSuperadminGroupsMappedLabelValue',
          getItemsDispatch: 'lmsSuperadminGroupsGet',
          itemName: ['group', 'groups'],
          searchQueryable: true,
          tableLabels: [
            {
              key: 'name',
              title: 'Name',
              type: 'string',
              sortable: true,
              queryable: true
            }
          ]
        })
      }

      filtersArr.push({
        key: 'trigger',
        label: 'On completion of',
        type: 'multiselect',
        getItemsGetter: 'getEbsCoursesMappedIdNameStatusLabels',
        getItemsGetterMapped: 'getEbsCoursesMappedLabelValue',
        getItemsDispatch: 'ebsCoursesGetAdmin',
        getPaginationGetter: 'getEbsCoursesPagination',
        itemName: ['course', 'courses'],
        searchQueryable: true,
        tableLabels: [
          {
            key: 'name',
            title: 'Name',
            type: 'string',
            sortable: true,
            queryable: true
          }
        ]
      })
      filtersArr.push({
        key: 'enrolTo',
        label: 'Enrol to',
        type: 'multiselect',
        getItemsGetter: 'getEbsCoursesMappedIdNameStatusLabels',
        getItemsGetterMapped: 'getEbsCoursesMappedLabelValue',
        getItemsDispatch: 'ebsCoursesGetAdmin',
        getPaginationGetter: 'getEbsCoursesPagination',
        itemName: ['course', 'courses'],
        searchQueryable: true,
        tableLabels: [
          {
            key: 'name',
            title: 'Name',
            type: 'string',
            sortable: true,
            queryable: true
          }
        ]
      })

      return filtersArr
    },
    routeQueryView () {
      return this.$route.query.view
    }
  },
  watch: {
    routeQueryView () {
      this.rerenderIndex++
    }
  },
  methods: {
    redirectToWorkflowsAdd () {
      this.$router.push({ name: 'ebs-workflows-add' })
    },
    redirectToWorkflowsLog () {
      this.$router.push({ name: 'ebs-workflows-log' })
    },
    switchView (value) {
      this.$router.push({ query: { view: value } })
    },
    initializeRouteQuery () {
      this.switchView('org-units')
    }
  },
  created () {
    this.initializeRouteQuery()
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/workflows/_workflowslist.scss";
</style>
